import React from 'react';
import { ServiceCard } from '../ui/ServiceCard';
import { Button } from '../ui/Button';
export function ServicesCards() {
  const services = [{
    image: 'https://cdn.magicpatterns.com/uploads/cJgJo3jxNKP9cfecdnATsg/car.png',
    title: 'Non-Emergency Medical Transportation (NEMT)',
    description: 'Reliable rides to doctor visits, dialysis, therapy, and more.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/gjUrPgMuo26V3xz4xf468e/wheel.png',
    title: 'Wheelchair & Mobility Assistance',
    description: 'Safe, ADA-compliant door-to-door transport with trained staff.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/j3vUM5RrksnH1puKF6hcqr/image_(1).png',
    title: 'Stretcher & Special Care Transport',
    description: 'Professional handling for clients needing stretcher transport.'
  }];
  return <section id="services" className="bg-white py-20" data-id="element-263">
      <div className="max-w-7xl mx-auto px-4" data-id="element-264">
        <div className="text-center mb-12" data-id="element-265">
          <h2 className="text-3xl lg:text-4xl font-bold text-[#0B1F3A] mb-6" data-id="element-266">
            Medical Transportation Services We Provide
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-267">
            Comprehensive medical transportation solutions tailored to your
            needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-268">
          {services.map((service, index) => <ServiceCard key={index} {...service} link="#contact" data-id="element-269" />)}
        </div>

        <div className="text-center" data-id="element-270">
          <Button variant="secondary" size="lg" onClick={() => document.getElementById('contact')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-271">
            View All Services
          </Button>
        </div>
      </div>
    </section>;
}